import { render } from "./bg.vue?vue&type=template&id=0194d385"
import script from "./bg.vue?vue&type=script&lang=ts"
export * from "./bg.vue?vue&type=script&lang=ts"

import "./bg.vue?vue&type=style&index=0&id=0194d385&lang=css"
script.render = render

export default script